import { Modal } from 'antd'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import useUpdateBlocktrainStatus from '../../../hooks/blocktrain/useUpdateBlocktrainStatus'
import { BlockTrainStatusEnum, BlocktrainType } from '../../../types'

interface Props {
  visible: boolean
  close: () => void
  blocktrain: BlocktrainType | null
}

const CancelBlocktrainModal: FC<Props> = ({ visible, close, blocktrain }) => {
  const { t } = useTranslation()
  const { updateBlocktrainStatus, updateBlocktrainStatusIsFetching } = useUpdateBlocktrainStatus()

  const handleCancel = () => {
    if (!blocktrain) return

    updateBlocktrainStatus({
      id: String(blocktrain.id),
      status: BlockTrainStatusEnum.CANCELED,
    })
    close()
  }

  return (
    <Modal
      title={t('cancel_blocktrain')}
      open={visible}
      onCancel={close}
      onOk={handleCancel}
      okButtonProps={{ loading: updateBlocktrainStatusIsFetching }}
      cancelText={t('cancel')}
      okText={t('confirm')}
      className="entity-modal"
    >
      <span className="subtitle-modal-wrap">
        {blocktrain
          ? `${t('blockTrain_Info')}: #${blocktrain.id ?? '-'} - ${
              blocktrain.supplier?.tradeName ?? '-'
            } - ${
              typeof blocktrain.origin === 'object' && blocktrain.origin !== null
                ? (blocktrain.origin as { city?: string }).city ?? '-'
                : typeof blocktrain.origin === 'string'
                ? blocktrain.origin
                : '-'
            } - ${blocktrain.railCarQuantity ?? '-'}`
          : ''}
      </span>
    </Modal>
  )
}

export default CancelBlocktrainModal
